<!--
 * @Author: your name
 * @Date: 2021-05-16 03:16:24
 * @LastEditors: 聪Cong
 * @LastEditTime: 2022-07-13 00:06:33
 * @FilePath: /卫星/weixing/src/page/help.vue
-->


<template>
  <div class="help">
    <Layout
      style="background: rgba(255, 255, 255, 0); height: 100%; width: 100%"
    >
      <Header style="background: rgba(255, 255, 255, 0); height: 10%"></Header>
      <Content>
        <Row class="Row" type="flex" justify="center">
          <Col flex="auto"> </Col>
          <Col flex="300px">
            <Card style="background: rgba(255, 255, 255, 0.4); ">
              <layout style="background: rgba(255, 255, 255, 0)">
                <div style="background: rgba(255, 255, 255, 0.2); padding: 5px">
                   <Card style="background: rgba(255, 255, 255, 0.1);">
                <p slot="title">网站更新日志</p>
                <p style=" text-align: left;">2022.07 添加IP地址计算功能</p>
                <p style=" text-align: left;">2022.07 优化功率和dbm换算功能</p>
                <p style=" text-align: left;">2022.07 优化菜单显示UI</p>
                <p style=" text-align: left;">2022.01 添加功率和dbm换算功能</p>
                <p style=" text-align: left;">2021.05 添加卫星角度计算功能</p>
                <p style=" text-align: left;">2021.05 添加经纬度获取功能</p>
                <p style=" text-align: left;">2021.05 添加陀螺仪获取角度功能</p>
            </Card>
                </div>
              </layout>
            </Card>
          </Col>
          <Col flex="auto"> </Col>
        </Row>
      </Content>
      <Footer
        style="
          color: #000;
          background: rgba(255, 255, 255, 0);
          text-align: center;
          padding-top: 5px;
        "
      >
        <p>卫星角度计算器 ©粤ICP备666号</p>
        <p>开发者:聪Cong</p>
      </Footer>
    </Layout>
  </div>
</template>


<script>
export default {
  name: "Help",
  components: {},
};
</script>

<style>
</style>